import { render } from "./MainBanner.vue?vue&type=template&id=62d373ba&scoped=true"
const script = {}

import "./MainBanner.vue?vue&type=style&index=0&id=62d373ba&scoped=true&lang=css"

import exportComponent from "C:\\Users\\EFRENBP\\Desktop\\Projects\\2022\\03-Landing referidos\\AM-referidos\\am-referrals router\\am-referrals\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62d373ba"]])

export default __exports__